import { render } from "./ClientsCRUD.vue?vue&type=template&id=3bca73b2&scoped=true"
import script from "./ClientsCRUD.vue?vue&type=script&lang=js"
export * from "./ClientsCRUD.vue?vue&type=script&lang=js"

import "./ClientsCRUD.vue?vue&type=style&index=0&id=3bca73b2&scoped=true&lang=css"
import "./ClientsCRUD.vue?vue&type=style&index=1&id=3bca73b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bca73b2"]])

export default __exports__